// 気象警報注意報
export const ALERT_KIND_STATUSES = {
  NEW: '発表',
  CANCEL: '解除',
  CONTINUE: '継続',
  CANCEL_SPECIAL: '特別警報から警報',
  CANCEL_ALERT: '警報から注意報',
  SWITCH: '切り替わり',
} as const

export type AlertKindStatuse = (typeof ALERT_KIND_STATUSES)[keyof typeof ALERT_KIND_STATUSES]

// 解除を表す気象警報注意報コード
export const ALERT_KIND_CANCEL_CODE = '00'

export type AlertKind = {
  name: string
  code: string
  level?: number
  status: AlertKindStatuse
}

export type Alert = {
  areaCode: number
  area: Area
  publishingOffice: string
  updatedAt: string
  kinds: AlertKind[]
}

export type Area = {
  name: string
  code: string
}

export type AlertData = {
  weatherWarningData: Alert[]
}
